import api from '../../helpers/axios';
import UserDataProps from '../props/UserDataProps';

/**
 * Login response from backend
 */
interface LoginResponse {
    message: string;
    user: UserDataProps;
}

/**
 * Validates the username and password by making an API call.
 * @param {string} email - The email to validate.
 * @param {string} password - The password to validate.
 * @returns {Promise<UserDataProps | null>} - Returns user data if validation is successful, otherwise null.
 */

const applicationDataHandler = {

};

export async function validateUsernameAndPassword(email: string, password: string): Promise<UserDataProps | null> {
    try {
        const response = await api.post<LoginResponse>('/api/auth/login', { email, password });
        // Backend now returns { message, user } with roles and permissions
        return response.data.user as UserDataProps;
    } catch (error) {
        // Handle error (e.g., invalid credentials)
        console.error('Login error:', error);
        return null;
    }
}

export async function signupUser(userData: UserDataProps): Promise<UserDataProps | null> {
    try {
        const response = await api.post('/api/auth/signup', userData);
        // Assuming the backend returns user data in response.data
        return response.data as UserDataProps;
    } catch (error) {
        // Handle error (e.g., invalid credentials)
        return null;
    }
}


export default applicationDataHandler;

